/**
 * Обёртка для РД над общим парсером координат (совместимость имён API).
 */

import {
  parseGeometryCoordsFromText,
  type CoordinateOrder,
  type GeometryCoordsParseResult,
} from "@/lib/geometry-coords-import";

export type RdCoordinateOrder = CoordinateOrder;

export type RdGeometryParseResult =
  | { ok: true; feature: GeoJSON.Feature }
  | { ok: false; error: string };

/**
 * Разбирает текст: GeoJSON (Geometry / Feature / FeatureCollection) или построчные координаты.
 */
export function parseRdGeometryFromText(
  raw: string,
  options?: { coordinateOrder?: RdCoordinateOrder },
): RdGeometryParseResult {
  const result: GeometryCoordsParseResult = parseGeometryCoordsFromText(raw, options);
  if (!result.ok) return result;
  return { ok: true, feature: result.feature };
}
